export default {"src":"/_next/static/media/recruiterIcon.1f4eb7c1.svg","height":46,"width":50};